var React = require('react');

function QuoteInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m230.566 3953c5.929 0 11.364-4.56 12.187-9.93.824-5.86-2.799-10.74-8.234-11.56 1.811-2.44 7.082-6.35 15.481-12.04l-5.435-8.47c-15.481 8.95-23.88 18.07-25.363 27.35-1.317 7.98 3.953 14.65 11.364 14.65zm39 0c5.929 0 11.364-4.56 12.187-9.93.824-5.86-2.799-10.74-8.234-11.56 1.811-2.44 7.082-6.35 15.481-12.04l-5.435-8.47c-15.481 8.95-23.88 18.07-25.363 27.35-1.317 7.98 3.953 14.65 11.364 14.65z","fill":"#fff","fillOpacity":".15","fillRule":"nonzero","transform":"translate(-219 -3911)"}));
}

QuoteInline.defaultProps = {"clipRule":"evenodd","fillRule":"evenodd","strokeLinejoin":"round","strokeMiterlimit":"2","viewBox":"0 0 70 42"};

module.exports = QuoteInline;

QuoteInline.default = QuoteInline;
